var b = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var f = (r, e, o) => e in r ? b(r, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[e] = o, y = (r, e) => {
  for (var o in e || (e = {}))
    l.call(e, o) && f(r, o, e[o]);
  if (t)
    for (var o of t(e))
      h.call(e, o) && f(r, o, e[o]);
  return r;
};
var I = (r, e) => {
  var o = {};
  for (var m in r)
    l.call(r, m) && e.indexOf(m) < 0 && (o[m] = r[m]);
  if (r != null && t)
    for (var m of t(r))
      e.indexOf(m) < 0 && h.call(r, m) && (o[m] = r[m]);
  return o;
};
import { jsx as j } from "react/jsx-runtime";
import d from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as k } from "react";
import { useTheme as v } from "styled-components";
import * as w from "./style.es.js";
import { Image as A } from "./style.es.js";
const a = k((R, x) => {
  var g = R, {
    alt: r = "Alt of the Image",
    errorSrc: e = "https://cdn.heroengage.com/assets/default-img.svg",
    height: o,
    name: m,
    src: u,
    width: T
  } = g, S = I(g, [
    "alt",
    "errorSrc",
    "height",
    "name",
    "src",
    "width"
  ]);
  var p, i, c;
  const s = v(), E = u || ((p = s.images) == null ? void 0 : p[m]) || e || ((i = s.images) == null ? void 0 : i.errorSrc);
  return /* @__PURE__ */ j(A, y({ alt: r, height: o, onError: (P) => {
    var n;
    P.target.src = e || ((n = s.images) == null ? void 0 : n.errorSrc);
  }, ref: x, src: E, width: T, fallback: e || ((c = s.images) == null ? void 0 : c.errorSrc) }, S));
}), N = {
  errorSrc: d.string,
  name: d.string
};
a.S = w;
a.displayName = "Image";
a.propTypes = N;
export {
  a as Image
};
//# sourceMappingURL=Image.es.js.map
